import React from 'react'
import { connect } from 'react-redux'
import { array, string } from 'prop-types'
// import SubTypes from './SubTypes'
import { Card, List, Image } from 'semantic-ui-react'
import SameSupport from '../../../../assets/img/same_support.png'
import SameLocation from '../../../../assets/img/same_location.png'
import CurrentLocation from '../../../../assets/img/pin2.png'
import '../styles/SubTypeLegends.css'

// const LegendsTitle = () => <li className="legends-title">Legends</li>

const SearchedLocation = ({ show, address }) =>
  show ? (
    <List.Item>
      <List.Content verticalAlign="bottom">
        <List.Header>
          {address}
          <Image
            floated="right"
            size="mini"
            src={CurrentLocation}
            verticalAlign="top"
            centered
          />
        </List.Header>
        <Card.Meta>This icon displays the address searched</Card.Meta>
      </List.Content>
    </List.Item>
  ) : null

const SubTypeLegends = ({ subTypes, theme, addressBasedSearch, address }) => (
  <Card.Group>
    <Card fluid color="blue">
      <Card.Content>
        <List>
          <List.Item>
            <List.Content verticalAlign="bottom">
              <List.Header>
                Signs on Same Support
                <Image
                  floated="right"
                  size="mini"
                  src={SameSupport}
                  verticalAlign="top"
                  centered
                />
              </List.Header>
              <Card.Meta>
                This icon represents signs that are in same support
              </Card.Meta>
            </List.Content>
          </List.Item>
          <List.Item>
            <List.Content verticalAlign="bottom">
              <List.Header>
                Signs nearby each other
                <Image
                  floated="right"
                  size="mini"
                  src={SameLocation}
                  verticalAlign="top"
                  centered
                />
              </List.Header>
              <Card.Meta>
                This icon represents signs that are nearby each others
              </Card.Meta>
            </List.Content>
          </List.Item>
          <SearchedLocation show={addressBasedSearch} address={address} />
        </List>
      </Card.Content>
    </Card>
  </Card.Group>
)

SubTypeLegends.propTypes = {
  subTypes: array.isRequired,
  theme: string.isRequired,
}

const mapStateToProps = ({ ui, spi, map, signsState }) => ({
  subTypes: ui.chartData.labels,
  theme: spi.theme,
  addressBasedSearch: map.addressBasedSearch,
  address: signsState.addressCache,
})

export default connect(mapStateToProps)(SubTypeLegends)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeLegends/index.jsx